import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SportService } from '../services/sport.service';

@Component({
  selector: 'app-lucky7',
  templateUrl: './lucky7.component.html',
  styleUrls: ['./lucky7.component.scss']
})
export class Lucky7Component implements OnInit {

  constructor(private sport: SportService,private router: Router,) { }
  iUrl: any;
  ngOnInit(): void {
  }
  gotoexchangeGame(cardData) {
    let data = {
      game_id : cardData
    }
    this.sport.lotusLaunch(data).subscribe((res) => {
      if(res.status == true){
        window.open(res.launchUrl, '_blank')
        // this.iUrl = res.launchUrl;
        // localStorage.setItem('casino',this.iUrl)
        // this.router.navigate(['casino-detail'])
      }
    })
  }
}
